import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { decodeAccessToken, getCookie } from '../../shared/utils';
import { refreshSession } from '../../store/auth/actionCreators';

const SessionManager = () => {
  const dispatch = useDispatch();
  const lastActive = useRef(Date.now());

  // Config
  const CHECK_INTERVAL = 60 * 1000; // Check every minute
  const REFRESH_THRESHOLD = 5 * 60 * 1000; // Refresh if < 5 mins left
  const IDLE_TIMEOUT = 30 * 60 * 1000; // User considered idle after 30 mins

  const updateActivity = () => {
    lastActive.current = Date.now();
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, updateActivity));

    return () => {
      events.forEach((event) =>
        window.removeEventListener(event, updateActivity),
      );
    };
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      const accessToken = getCookie('access_token');
      const refreshToken = getCookie('refresh_token');

      if (!accessToken || !refreshToken) return;

      // Decode token to get exp
      const payload = decodeAccessToken(accessToken);
      if (!payload?.exp) return;

      const expTime = payload.exp * 1000;
      const timeLeft = expTime - Date.now();
      const timeSinceActive = Date.now() - lastActive.current;

      if (timeLeft < REFRESH_THRESHOLD) {
        if (timeSinceActive < IDLE_TIMEOUT) {
          // @ts-ignore
          dispatch(refreshSession(refreshToken));
        }
      }
    }, CHECK_INTERVAL);

    return () => clearInterval(interval);
  }, [dispatch]);

  return null;
};

export default SessionManager;
